//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      currentValue: this.value,
      loading: false
    }
  },
  methods: {
    onChange (e) {
      if (this.$refs.input.files[0]) {
        // this.currentValue = undefined
        this.loading = true
        this.axios.upload(this.$refs.input.files[0])
        .then(response => {
          this.loading = false
          if (response.data.data) {
            this.currentValue = response.data.data.filename
          }
        })
        .catch(error => {
          this.loading = false
          return Promise.reject(error)
        })
      }
    }
  },
  watch: {
    currentValue (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.currentValue = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/file-upload/index.vue